'use client';

import { memo, useEffect } from 'react';

import { SubHeader } from '@/app/_components/layout';
import { useNavbarScrolled } from '@/hooks';
import { cn } from '@nextui-org/react';

import Navbar from './Navbar';

import Aos from 'aos';

const Header = () => {
	const { isScrolled, navRef } = useNavbarScrolled();
	useEffect(() => {
		console.log('init');
		Aos.init({
			delay: 100,
		});
	}, []);

	return (
		<div>
			<header
				className={cn(
					'transition-background fixed inset-x-0 top-0 z-[9999] shrink-0 bg-white',
					{
						'bg-bittersweet': isScrolled,
					}
				)}
			>
				<SubHeader />

				<Navbar ref={navRef} isScrolled={isScrolled} />
			</header>
		</div>
	);
};

export default memo(Header);
